module.exports = __webpack_public_path__ + "img/871-6b980a.png";